module.exports = __webpack_public_path__ + "static/media/bg_tourist.2f480fb3.png";